const JsTimeline = {
    init(AOS) {

        // Timeline Nav
        // Commented because the category archive tag doesn't give a count, so can't use that anyway
        //   if ( $('.timeline-nav').length ) {

        //    $('.timeline-nav-menu').find('.timeline-link').each(function(i) {
        //      // We need to adjust the targeting index, because Expression Engine unfortunately believes in the fallacy that is "arrays start at 1"
        //      let targetIndex = i + 1;
        //      $(this).attr('href', '#timeline-' + targetIndex);
        // });

        //   }

        // Amount of card overlap
        const cardOverlap = 90;
        const presentYearSpace = 92;
        const initialYearSpace = 120;

        // Timeline
        if ($('.timeline').length) {
            AOS.init();

            // Get first year of timeline
            $('.timeline').each(function( timelineKey, timelineValue) {

                let timelineColour = $(this).data('timeline-colour');

                // Find and assign start year for this timeline
                let timelineStartYear = $(this).find('.timeline-body').find('.time').first().data('timeline-year');
                $(this).find('.start-year').find('.year-text').text(timelineStartYear);

                let timelineYears = [];

                // Filter through individual time entries and add year class where there's a new year
                var timelineYearList = $(this).find('[data-timeline-year]').filter(function() {
                    let timelineYear = $(this).data('timeline-year');

                    if ($.inArray(timelineYear, timelineYears) !== -1) {
                        // timelineYear already accounted for, return false
                        return false;
                    } else {
                        // first of this timelineYear
                        timelineYears.push(timelineYear);

                        // Now we add a class to display the year
                        $(this).addClass('year');
                        return true;
                    }
                });

                let timelineObj = $(this);

                if (Foundation.MediaQuery.atLeast('medium')) {
                  eachTimeline(timelineObj, timelineKey);
                }

                $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
                  // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint

                  if (Foundation.MediaQuery.atLeast('medium')) {
                    eachTimeline(timelineObj, timelineKey);
                  }
                });


            });

            /**
             * Colour Transitions
             */

            $('.timeline-container').css("background-color", 'rgb(0,44,66)');

            // Get the height of each timeline
            // var $timelines = $('[id^=timeline-]').not('#timeline-title-text').not('section');
            var $timelines = $('.timeline');
            var timeline = [];

            function animationsTest(callback) {
                // Test if any page animations are currently active
                var testAnimationInterval = setInterval(function() {
                    if (!$.timers.length) { // any page animations finished
                        clearInterval(testAnimationInterval);
                        callback();
                    }
                }, 25);
            }

            animationsTest(function() {
                var timeline = {};
                var timelineConfig = [];

                // blue, pink, green, gray,
                // cyan, brown, purple, red, yellow
                var timelineColors = [
                    'rgb(15,96,165)', 'rgb(158,0,93)', 'rgb(90,115,2)', 'rgb(75,75,75)',
                    'rgb(0,112,104)', 'rgb(66,33,11)', 'rgb(108,96,148)', 'rgb(165,30,34), rgb(187,150,78)'
                ];

                $timelines.each(function(index) {
                    // console.log(index);
                    if (index === 0) {
                        timelineConfig[index] = {};
                        timelineConfig[index].startPos = 0;
                        timelineConfig[index].endPos = $(this).height() + 120;
                        timelineConfig[index].height = 0;
                    } else {
                        timelineConfig[index] = {};
                        timelineConfig[index].startPos = timelineConfig[index - 1].endPos + 1;
                        timelineConfig[index].endPos = timelineConfig[index].startPos + $(this).height() + 120;
                    }
                });

                var timelineHeight = 0;

                timelineConfig.forEach(function(value, index) {
                    // calculate timeline heights
                    timelineHeight = (timelineConfig[index].endPos - timelineConfig[index].startPos) + 120;
                    // console.log("Timeline Height");
                    // console.log(timelineHeight);

                    if (index === 0) {
                        timelineConfig[index].height = timelineHeight;
                        timelineConfig[index].endingColor = timelineColors[index + 1];
                    } else if (index == timelineConfig.length - 1) {
                        timelineConfig[index].endingColor = timelineColors[index];
                    } else {
                        timelineConfig[index].endingColor = timelineColors[index + 1];
                    }

                    timelineConfig[index].beginningColor = timelineColors[index];
                    timelineConfig[index].height = timelineHeight;
                });

                timelineConfig.forEach(function(value, index) {
                    timeline[index] = new AnimateColours(timelineConfig[index]);
                });

                // Kick in initial color
                $('.timeline-container').css('background-color', timelineColors[0]);
            });

            /**
             * Animate the background colours
             *
             * @param timelineConfig
             */
            function AnimateColours(timelineConfig) {
                this.timelineConfig = timelineConfig;
                var scroll_pos = 0;

                var animation_begin_pos = this.timelineConfig.startPos; //where we want the animation to begin
                var animation_end_pos = this.timelineConfig.endPos; //where we want the animation to stop

                var obj = this.timelineConfig;
                var beginning_color = new $.Color(this.timelineConfig.beginningColor);
                var ending_color = new $.Color(this.timelineConfig.endingColor);

                $(document).scroll(function() {
                    scroll_pos = $(this).scrollTop();

                    if (scroll_pos >= (obj.startPos) && scroll_pos <= (obj.endPos)) {
                        // console.log('scrolling and animating');
                        //we want to calculate the relevant transitional rgb value
                        var percentScrolled = (scroll_pos - (obj.startPos)) / ((obj.endPos - obj.startPos));

                        var newRed = beginning_color.red() + ((ending_color.red() - beginning_color.red()) * percentScrolled);
                        var newGreen = beginning_color.green() + ((ending_color.green() - beginning_color.green()) * percentScrolled);
                        var newBlue = beginning_color.blue() + ((ending_color.blue() - beginning_color.blue()) * percentScrolled);
                        var newColor = new $.Color(newRed, newGreen, newBlue);

                        $('.timeline-container').animate({
                            backgroundColor: newColor
                        }, 0);
                    }
                });
            }

        }

        /**
         * Timeline each function (here we're going to break down each timeline and calculate heights)
         *
         * @param timelineObject, timelineKey
         */
        function eachTimeline(timeline, timelineKey) {
          // Loop through each group of timeline entries and apply height to the container
          $(timeline).find('.timeline-body').each(function (i, v) {
            let timelineBodyHeight = $(this).outerHeight();
            let heightTarget = timelineBodyHeight + 'px'
            $(v).css('height', heightTarget);

            let actualHeightOdd = [];
            let actualHeightEven = []

            let timeCount = $(this).find('.time').length;

            setTimeout(() => {
              $(this).find('.time').each(function (i, v) {

                let height = $(this).outerHeight(true);

                if ( i === 1 ) {
                  let timeHeight = $(this).prev().outerHeight();
                  height = height + cardOverlap + (timeHeight / 2);
                } else {
                  height = height + cardOverlap;
                }

                if ( i % 2 == 0 ) {
                  actualHeightEven.push(height);
                  $(this).find('.c-card').attr('data-aos', 'fade-right');
                  // {if count % 2 == 0} data-aos="fade-right" {if:else} data-aos="fade-left" {/if}
                } else {
                  actualHeightOdd.push(height);
                  $(this).find('.c-card').attr('data-aos', 'fade-left');
                }

                if ( i === 0 ) {
                  $(v).css('position', 'absolute');
                }

                if ( i === 1 ) {

                  // console.log("Time height");
                  let timeHeight = $(this).prev().outerHeight();
                  // console.log(timeHeight);

                  // console.log("Previous element relative to parent");
                  let topElementRelative = $(this).prev().position().top;
                  // console.log(bottomElementRelative);

                  let targo = (topElementRelative + (timeHeight / 2)) + 'px';

                  $(v).css('position', 'absolute');
                  $(v).css('top', targo);
                }

                if ( i >= 2 ) {

                  // console.log("Time height");
                  let timeHeight = $(this).prev().prev().outerHeight();
                  // console.log(timeHeight);

                  // console.log("Previous element relative to parent");
                  let bottomElementRelative = $(this).prev().prev().position().top + $(this).prev().prev().outerHeight(true);
                  // console.log(bottomElementRelative);

                  let targo = (bottomElementRelative + cardOverlap) + 'px';

                  $(v).css('position', 'absolute');
                  $(v).css('top', targo);
                }
              });

              let finalHeightEven = actualHeightEven.reduce((a, b) => a + b, 0);
              let finalHeightOdd = actualHeightOdd.reduce((a, b) => a + b, 0);

              let finalApplicableHeight = Math.max(finalHeightEven,finalHeightOdd);

              if ( timelineKey === 0 ) {
                // 92 is height of present year li, we minus cardOverlap because the first card isn't messed with
                finalApplicableHeight = finalApplicableHeight + ( presentYearSpace - cardOverlap );
              } else {
                // 120 is height of initial year li, we minus cardOverlap because the first card isn't messed with
                finalApplicableHeight = finalApplicableHeight + ( initialYearSpace - cardOverlap);
              }

              let finalHeightTarget = finalApplicableHeight + 'px'
              $(v).find('ul').css('height', finalHeightTarget);
              $(v).css('height', finalHeightTarget);

              AOS.init();

            }, 500);

          });
        }


        // Timeline Text Read More
        if ($('.timeline-text__read-more').length) {
          $('.timeline-text__read-more').click(function() {
              $('.timeline__text--long').removeClass('hide');
              $('.timeline__text--short').addClass('hide');
          });
        }
    }
};

export default JsTimeline;



// WEBPACK FOOTER //
// ./src/components/03-ui/timeline/timeline.js